import React, { ReactNode } from 'react';

export const GroupHeaderTemplate = (_props: { children: ReactNode[] | ReactNode }): JSX.Element => (
  <></>
);
